import { ILanguageImplementation } from '../languageBundle';

export const ENGLISH_TEXTS: ILanguageImplementation = {
  'en-US': {
    DashboardTitle: 'Title of the dashboard',
    NavbarTitle: 'Inventory Manager',
  },
};
